<template>
  <div>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/GeneralComponents/FooterComponent.vue"
export default {
  name:"App",
  components:{
    Footer,
  }
}
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Roboto Condensed", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
nav {
  padding: 30px;
  background: #DDDEE0;
}
.link{
  text-decoration: none;
}
.link2{
  text-decoration: none;
  color: white;
}
.btn {
  font-size: 15px;
  text-decoration-color: white;
}
.link2:hover{
  color: white;
}
.card {
  border-radius: 10px;
}
.lblform {
  text-align: left;
}
.inputForm {
  text-align: left;
  border: 0.3px;
  width: 170px;
  min-width: 120px;
}
td {
  padding: 10px;
  vertical-align: top;
}
.cardRegister{
    background-color: #F2F2F2;
    border-radius: 10px;
}

</style>
